/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseDCNoteInterface {
  "id"?: number;
}

export class ERPpurchaseDCNote implements ERPpurchaseDCNoteInterface {
  "id": number;
  constructor(data?: ERPpurchaseDCNoteInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchaseDCNote`.
   */
  public static getModelName() {
    return "ERPpurchaseDCNote";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchaseDCNote for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseDCNoteInterface): ERPpurchaseDCNote{
    return new ERPpurchaseDCNote(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchaseDCNote',
      plural: 'ERPpurchaseDCNotes',
      path: 'ERPpurchaseDCNotes',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchaseDCNote.ts